import { FieldType, FieldValueInterface as CrmFieldValueInterface } from '@vendasta/crm';

const compareStringList = (currentValue: CrmFieldValueInterface, modifiedValue: CrmFieldValueInterface): boolean => {
  const currentValues = currentValue.stringValues?.values || [];
  const modifiedValues = modifiedValue.stringValues?.values || [];
  const sortedCurrentValues = currentValues.sort();
  const sortedModifiedValues = modifiedValues.sort();

  if (sortedCurrentValues.length !== sortedModifiedValues.length) {
    return true;
  }
  for (const [index, value] of sortedCurrentValues.entries()) {
    if (value !== sortedModifiedValues[index]) {
      return true;
    }
  }
  return false;
};

const currencyIsModified = (current: CrmFieldValueInterface, modified: CrmFieldValueInterface): boolean => {
  const valueModified = (current.currencyValue?.value || 0) !== (modified.currencyValue?.value || 0);
  const codeModified = (current.currencyValue?.currencyCode || '') !== (modified.currencyValue?.currencyCode || '');
  return valueModified || codeModified;
};

export const isModifiedFieldValue = (
  currentValue: CrmFieldValueInterface,
  modifiedValue: CrmFieldValueInterface,
  fieldType: FieldType,
): boolean => {
  switch (fieldType) {
    case FieldType.FIELD_TYPE_INTEGER:
      return (currentValue?.integerValue ?? null) !== (modifiedValue?.integerValue ?? null);
    case FieldType.FIELD_TYPE_FLOAT:
      return (currentValue?.floatValue ?? null) !== (modifiedValue.floatValue ?? null);
    case FieldType.FIELD_TYPE_STRING:
    case FieldType.FIELD_TYPE_DROPDOWN:
    case FieldType.FIELD_TYPE_EMAIL:
      return (currentValue?.stringValue || '') !== (modifiedValue?.stringValue || '');
    case FieldType.FIELD_TYPE_PHONE:
      return (currentValue?.phoneFieldValues || '') !== (modifiedValue?.phoneFieldValues || '');
    case FieldType.FIELD_TYPE_BOOLEAN:
      return (currentValue?.booleanValue || false) !== (modifiedValue?.booleanValue || false);
    case FieldType.FIELD_TYPE_TAG:
    case FieldType.FIELD_TYPE_STRING_LIST:
      return compareStringList(currentValue, modifiedValue);
    case FieldType.FIELD_TYPE_DATETIME:
    case FieldType.FIELD_TYPE_DATE:
      return currentValue.dateValue?.getTime() !== modifiedValue.dateValue?.getTime();
    case FieldType.FIELD_TYPE_CURRENCY:
      return currencyIsModified(currentValue, modifiedValue);
    default:
      return false;
  }
};
